const SurveyQuestionType = {
    GENERAL : 'GENERAL',
    LIST : 'LIST',
    MOBULE_NUMBER : 'MOBILE',
    DATE : 'DATE',
    NATIONAL_ID : 'NATIONALID',
    ONE_WORD : 'ONEWORD'
}
export default SurveyQuestionType